import { gsap } from '../../global/gsap';

// Global settings
const animationDefaults = { duration: 1.5, ease: 'power3.out' };
const debounceInterval = 100;

// Based on https://gras.co as per comment in design
const initHomeGrid = (container) => {
    const inner = container.querySelector('.js-grid-inner');
    if (!inner) return;

    // quickTo creates a reusable setter — cheaper than new tween every mousemove
    const xTo = gsap.quickTo(inner, 'x', animationDefaults);
    const yTo = gsap.quickTo(inner, 'y', animationDefaults);

    // How many pixels the inner overflows the container on each axis.
    let overflowX = 0;
    let overflowY = 0;

    // Last known normalised mouse position — defaults to center
    let mx = 0.5;
    let my = 0.5;

    // Calculate mouse move coordinates based on window, as container takes viewport
    function onMouseMove(e) {
        mx = e.clientX / window.innerWidth;
        my = e.clientY / window.innerHeight;
        xTo(-mx * overflowX);
        yTo(-my * overflowY);
    }

    function cacheOverflow() {
        overflowX = inner.offsetWidth - container.offsetWidth;
        overflowY = inner.offsetHeight - container.offsetHeight;
    }

    cacheOverflow();

    // Snap to center before fade-in
    gsap.set(inner, {
        x: -mx * overflowX,
        y: -my * overflowY
    });

    // Debounce resize
    let resizeTimer;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
            cacheOverflow();
            xTo(-mx * overflowX);
            yTo(-my * overflowY);
        }, debounceInterval);
    });

    // Intro animation
    const header = document.querySelector('.js-header');
    const heroContent = document.querySelector('.js-hero-content');
    const tagline = heroContent.querySelector('h2');
    const cta = heroContent.querySelector('.button');
    const logo = heroContent.querySelector('svg');
    const logoPaths = logo.querySelectorAll('path');

    gsap.set([header, logo, tagline, cta], {
        opacity: 0
    });

    gsap.set(logoPaths, {
        opacity: 0,
        x: -25
    });

    gsap.set(logo, {
        opacity: 1,
        scale: 1.2,
        transformOrigin: 'center'
    });

    const heroTl = gsap.timeline({
        defaults: {
            ease: 'power3.out'
        },
        onComplete: () => container.addEventListener('mousemove', onMouseMove)
    });

    heroTl.to(logoPaths, {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: 0.05
    }).to(logo, {
        scale: 1,
        delay: 0.25
    }).to([header, tagline, cta], {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
    }).to(inner, {
        opacity: 1,
        duration: 0.5,
        delay: -0.5
    });
};

export { initHomeGrid as default };
